module.exports = __webpack_public_path__ + "static/media/icons-ic-whisper.59fc3d32.svg";